import { Document, Page, pdfjs } from 'react-pdf';
import { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

const LeitorPDF = ({ file, onClose }) => {
    const [pageNumber, setPageNumber] = useState(1);
    const [numPages, setNumPages] = useState(null);
    const [scale, setScale] = useState(1); // Zoom inicial
    const [containerWidth, setContainerWidth] = useState(null);

    const containerRef = useRef();

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setPageNumber(1);
    }

    useEffect(() => {
        if (containerRef.current) {
            setContainerWidth(containerRef.current.offsetWidth);
        }

        const handleResize = () => {
            if (containerRef.current) {
                setContainerWidth(containerRef.current.offsetWidth);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


    return (
        <Modal show={!!file} onHide={onClose} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title>Leitura do Diário</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div ref={containerRef}>
                    <Document
                        file={file}
                        onLoadSuccess={onDocumentLoadSuccess}
                        onLoadError={(error) => console.error("Erro ao carregar PDF:", error)}
                        loading={<div>Preparando o Diário para Leitura...</div>}
                    >
                        <Page
                            pageNumber={pageNumber}
                            width={containerWidth ? containerWidth * scale : undefined}
                        />
                    </Document>
                </div>
                <div className="mt-3 text-center">
                    <Button
                        variant="secondary"
                        onClick={() => setPageNumber((p) => Math.max(p - 1, 1))}
                        disabled={pageNumber <= 1}
                        className="mx-2"
                    >
                        Página Anterior
                    </Button>
                    <span>
                        Página {pageNumber} de {numPages}
                    </span>
                    <Button
                        variant="secondary"
                        onClick={() => setPageNumber((p) => Math.min(p + 1, numPages))}
                        disabled={pageNumber >= numPages}
                        className="mx-2"
                    >
                        Próxima Página
                    </Button>
                </div>
                <div className="text-center mt-3">
                    <Button
                        variant="outline-primary"
                        onClick={() => setScale((s) => s + 0.1)}
                        className="mx-2"
                    >
                        🔍 Zoom +
                    </Button>
                    <Button
                        variant="outline-primary"
                        onClick={() => setScale((s) => Math.max(0.5, s - 0.1))}
                        className="mx-2"
                    >
                        🔎 Zoom –
                    </Button>
                </div>
                <div className="text-center mt-3">
                    <Button
                        variant="warning"
                        href={file}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        🖨️ Imprimir
                    </Button>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={onClose}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default LeitorPDF;
